module.exports = __webpack_public_path__ + "static/img/game2_bg.46d53773.png";